import type en from "../en/voicelab";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  metaTitle: "مختبر الأصوات",
  title: "مختبر الأصوات",
  description: "قارن مزوّدي تحويل النص إلى كلام على جملك الخاصة — الدارجة المغربية، المصرية، السعودية، الفرنسية، الإنجليزية… — ثم اختر الصوت الذي يتكلم بكل لغة في مكالمات الذكاء الاصطناعي، بشكل منفصل للشخصيات النسائية والرجالية.",
  back: "الذكاء الاصطناعي والأرصدة",
  open: "فتح مختبر الأصوات",

  providersTitle: "المزوّدون",
  providersDesc: "الصق مفتاح API لكل مزوّد تريد تجربته. تُحفظ المفاتيح مشفّرة على الخادم ولا تُعرض مرة أخرى.",
  keyLabel: "مفتاح API",
  keyPlaceholder: "الصق مفتاحًا جديدًا",
  keySaved: "المفتاح محفوظ ({hint})",
  keyEnv: "مفتاح من بيئة الخادم ({hint})",
  keyMissing: "لا يوجد مفتاح",
  saveKey: "حفظ",
  removeKey: "حذف المفتاح",
  tune_stability: "الثبات",
  tune_similarityBoost: "التشابه",
  tune_style: "الأسلوب",
  tune_speed: "السرعة",
  tuneReset: "إعادة الضبط",
  tuneHint: "للمحادثة الطبيعية: الثبات ≈ 0.5 (أقل = أكثر تعبيرًا، أعلى = أكثر ثباتًا)، التشابه ≈ 0.75، الأسلوب 0 (الأعلى يزيد التأخير)، السرعة 0.95–1.05. يقبل Eleven v3 قيم الثبات 0 أو 0.5 أو 1 فقط. تُحفظ هذه الإعدادات مع الصوت عند الضغط على «استخدام».",
  customTuning: "تعديل إعدادات الصوت",
  ownSettingsHint: "يستخدم كل صوت إعداداته المحفوظة الخاصة — نفس الإعدادات التي صُنعت بها عيّناته. فعّل «تعديل إعدادات الصوت» فقط إذا أردت تغييرها.",
  fixesTitle: "تصحيحات النطق · {lang}",
  fixesHint: "عندما تُقرأ كلمة بشكل خاطئ (مثل «الخلاص» بالدارجة تُقرأ كالفصحى)، اكتبها كما يجب أن تُنطق — أضف سكونًا (ْ) أو شدّة (ّ)، أو احذف الحركة، أو اكتبها كما تُلفظ. زر «استمع» يجرّبها قبل الحفظ؛ وبعد الحفظ تستخدمها المكالمات أيضًا.",
  fixWord: "الكلمة",
  fixSay: "تُنطق هكذا",
  fixAdd: "+ إضافة كلمة",
  verifiedWith: "مُتحقق منه مع {model}",
  voiceFor: "الصوت لـ",
  defaultFor: "كل الشخصيات ({gender}) — افتراضي",
  colPersonas: "الشخصيات",
  usesDefault: "يستخدم صوت {gender} الافتراضي",
  modelLabel: "النموذج",
  getKey: "الحصول على مفتاح",
  saved: "تم الحفظ.",

  labTitle: "استمع وقارن",
  labDesc: "اختر لغة أو لهجة وجنسًا ومزوّدًا، حمّل أصواته واضغط استمع. يُظهر الوقت المدة التي استغرقها المزوّد (الأقل أفضل للمكالمات).",
  language: "اللغة / اللهجة",
  gender: "الشخصية",
  female: "امرأة",
  male: "رجل",
  sampleText: "الجملة المقروءة",
  resetSample: "جملة المثال",
  provider: "المزوّد",
  loadVoices: "تحميل الأصوات",
  searchPlaceholder: "تصفية بالاسم أو اللهجة",
  noVoices: "لا توجد أصوات لهذا التصفية.",
  noKey: "أضف مفتاحًا لهذا المزوّد أولًا.",
  listen: "استمع",
  stop: "إيقاف",
  preview: "عيّنة المزوّد",
  latency: "{ms} مللي ثانية",
  use: "استخدام لـ {lang} · {gender}",
  inUse: "مستخدم",
  sourceLibrary: "المكتبة",
  sourceAccount: "أصواتي",
  sourceBuiltin: "مدمج",
  voiceCount: "{count} صوت",

  assignmentsTitle: "الأصوات المستخدمة في المكالمات",
  assignmentsDesc: "اللهجة التي ليس لها صوت خاص تستخدم صف العربية (الفصحى). لا تحصل الشخصية أبدًا على صوت من الجنس الآخر؛ وبدون صوت محدد تستخدم المكالمات أصوات المتصفح من الجنس الصحيح أو النص المكتوب.",
  colLanguage: "اللغة",
  notSet: "غير محدد",
  clear: "إزالة",
  fallsBack: "يستخدم {lang}",
};

export default ar;
